import { render, staticRenderFns } from "./BaseAppendButton.vue?vue&type=template&id=fbc9b7e8"
import script from "./BaseAppendButton.vue?vue&type=script&lang=js"
export * from "./BaseAppendButton.vue?vue&type=script&lang=js"
import style0 from "./BaseAppendButton.vue?vue&type=style&index=0&id=fbc9b7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports